import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

const useEventCollection = () => {
  const { locale } = useLocalization()

const data = useStaticQuery(graphql`
  query AllCollectionEventsHookQuery {
    events: allCollectionEvents(sort: { date: ASC }) {
      nodes {
        id
        title
        teaserExcerpt
        teaserImage {
          url
        }
        url
        locale
        date
      }
    }
  }
`)

  /**
   * Get all Events in the current locale
   */
  return React.useMemo(() => {
    const now = new Date()

    return data.events.nodes
      .filter(n => n.locale === locale)
      .reduce(
        (acc, item) => {
          const itemdate = new Date(item.date)
          if (itemdate > now) {
            acc.upcoming.push(item)
          } else {
            acc.passed.push(item)
          }

          return acc
        },
        { upcoming: [], passed: [] }
      )
  }, [data, locale])
}

export default useEventCollection
